class AnalyticsService {
  _userIdentified = false;

  _orgTraits;

  _userTraits;

  constructor() {
    // Ensures the AnalyticsService is a singleton
    if (AnalyticsService._instance) {
      return AnalyticsService._instance;
    }
    AnalyticsService._instance = this;
  }

  _buildContext(passThroughContext) {
    return {
      groupId: this._orgTraits?.organizationId,
      ...passThroughContext,
      traits: {
        email: this._userTraits?.email,
        ...passThroughContext?.traits,
      },
    };
  }

  identifyUser(userId, traits) {
    if (!userId || this._userIdentified) {
      return;
    }
    window.analytics?.identify(userId, traits, () => {
      // Callback gives the identify call some time to process before we call group
      this._userIdentified = true;
      this._userTraits = traits;
      const { organization: orgTraits } = traits;
      if (!orgTraits) {
        return;
      }
      this._orgTraits = orgTraits;
      window.analytics?.group(orgTraits.organizationId, orgTraits);
    });
  }

  track(event, properties, context) {
    if (!event) {
      return;
    }
    window.analytics?.track(event, properties, this._buildContext(context));
  }

  page(name, properties, context) {
    if (!name) {
      return;
    }
    window.analytics?.page(name, properties, this._buildContext(context));
  }
}

export default new AnalyticsService();
